export default __webpack_public_path__ + "static/media/batmath.66a244bc.png";